import { Maybe } from "@graphql-tools/utils";
import { useTranslation } from "react-i18next";
import { GeneralFieldController } from "../../controllers/general-field-controller";
import { FlexControlProps } from "./flex-field-controller";
import { getEnumValues } from "../../utils/get-enum-values";
import { LdlTestUom } from "../generated/graphql";

export class LdlLevelUoMFieldController extends GeneralFieldController {
	override useControlProps(): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();
		const options = getEnumValues(LdlTestUom).map((v) => ({ label: t(v), value: v }));

		return {
			controlType: "typeahead",
			options: options,
			property: "value",
			selectPropertyValue: true,
		};
	}
}
